import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  setActivePageTab,
  toggleTabVisibility,
} from '../../../reducers/documentation/documentationPageReducer';
import { useDocumentationApiFacade } from '../../../apis/facades/useDocumentationApiFacade';
import { telemetry } from '../../../telemetry';

export const useDocumentationTabs = (crmOrgId: string) => {
  const dispatch = useDispatch();
  const { delete_metadataType, post_metadata } = useDocumentationApiFacade();

  const onAddMetadata = useCallback(
    (tabId: string, isPinned: boolean) => {
      //optimistic update
      dispatch(toggleTabVisibility({ pageTypeId: tabId, isVisible: true, crmOrgId }));

      if (isPinned) {
        return;
      }

      try {
        post_metadata(tabId);
      } catch (error) {
        telemetry.captureError('Error adding metadata type', { error });
      }
    },
    [dispatch, post_metadata, crmOrgId],
  );

  const onRemoveMetadata = useCallback(
    (tabId: string) => {
      //optimistic update
      dispatch(toggleTabVisibility({ pageTypeId: tabId, isVisible: false, crmOrgId }));
      try {
        delete_metadataType(tabId);
      } catch (error) {
        telemetry.captureError('Error removing metadata type', { error });
      }
    },
    [dispatch, delete_metadataType, crmOrgId],
  );

  const setActiveTab = useCallback(
    (tabId: string) => {
      dispatch(setActivePageTab({ tabId }));
    },
    [dispatch],
  );

  return { onAddMetadata, onRemoveMetadata, setActiveTab };
};
